import { createRoot, hydrateRoot } from "react-dom/client";
import { Router } from "wouter";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root")!;

// In production the Express server pre-renders the full page HTML via the SSR
// bundle (dist/server/entry-server.cjs) before serving it to the browser.
// hydrateRoot attaches React to that existing DOM without a full re-render.
//
// In development, Vite serves index.html with an empty <div id="root">.
// The SSR bundle is not built/loaded, so #root has no server-rendered content.
// hydrateRoot on an empty div throws hydration mismatch errors; use createRoot.
if (import.meta.env.PROD) {
  hydrateRoot(
    rootEl,
    <Router>
      <App />
    </Router>
  );
} else {
  createRoot(rootEl).render(
    <Router>
      <App />
    </Router>
  );
}
